import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const NavStatActiveIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22 2.25H2C1.04 2.25 0.25 3.04 0.25 4V20C0.25 20.96 1.04 21.75 2 21.75H22C22.96 21.75 23.75 20.96 23.75 20V4C23.75 3.04 22.96 2.25 22 2.25ZM20.78 11.28C20.78 11.83 20.33 12.28 19.78 12.28C19.23 12.28 18.78 11.83 18.78 11.28V10.14L12.96 15.96C12.57 16.35 11.94 16.35 11.55 15.96L8.76 13.17L4.47 17.46C4.08 17.85 3.45 17.85 3.06 17.46C2.67 17.07 2.67 16.44 3.06 16.05L8.06 11.05C8.45 10.66 9.08 10.66 9.47 11.05L12.26 13.84L17.37 8.73H16.23C15.68 8.73 15.23 8.28 15.23 7.73C15.23 7.18 15.68 6.73 16.23 6.73H19.79C20.34 6.73 20.79 7.18 20.79 7.73V11.29L20.78 11.28Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

NavStatActiveIcon.displayName = 'NavStatActiveIcon';
